import React,{useState,useEffect} from 'react';
import {css} from 'emotion';
import Input from '../common/material-easy-ui/input/Input';
import InputPassword from '../common/material-easy-ui/input/InputPassword'
import pnc_logo from '../../image/logo/pnc_logo.jpg';
import ButtonEasy from '../common/material-easy-ui/button/ButtonEasy';
import {goConnectUser} from '../../redux/actions/userActions';
import {useDispatch,useSelector} from 'react-redux';
import history from '../../utils/history';
import ModalForgetPassword from './components/ModalForgetPassword';

const LoginPage = (props) =>{
  const dispatch = useDispatch();
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [pwdError,setPwdError] = useState(false);
  const [emailError,setEmailError] = useState(false);
  const [forgetPassword,setForgetPassword] = useState(false);


  const error_log_type = useSelector(state=>state.user.error_log_type);
  const loading_connect = useSelector(state=>state.user.loading_connect);


  const onCloseModal = () =>{
    setForgetPassword(false);
  }

  const onChangeEmail = e => setEmail(e.target.value);
  const onChangePassword = e => setPassword(e.target.value);

  const onBlurPassword = () =>{
      console.log("")
 }

 const onSignIn = () =>{
  !loading_connect && dispatch(goConnectUser(email,password))
   .then((data)=>{
     history.replace({pathname:'/',state:{from:'/login'}})
     localStorage.setItem('pnc_popkey',data.payload.auth_token)

   })
 }

 const goToSignUp = () =>{
   history.push({pathname:'/signin'})
 }

 useEffect(()=>{
   if(error_log_type){
      if(error_log_type == 1){
      setEmailError({error:true,message:"L'utilisateur n'existe pas"});
      if(pwdError) setPwdError(false);

    }
    else if(error_log_type == 2){
      if(emailError) setEmailError(false);
      setPwdError({error:true,message:"Il y a une erreur de mot de passe"});

    }
    else{
      if(emailError) setEmailError(false);
      if(pwdError) setPwdError(false);
      alert("Une erreur critique est survenue");
    }
  }
  else {
    if(emailError) setEmailError(false);
     if(pwdError) setPwdError(false);
  }
 },[error_log_type])

  return(
    <div className={css`width:100vw;height:100vh;background-color:white;display:flex;align-items:center;justify-content:center`}>
      <div className={css`width:500px;
                        border:1px solid rgba(24, 62, 100,0.1);
                        -moz-box-shadow: 3px 3px 14px 0px rgba(24, 62, 100,0.1);
                        -webkit-box-shadow: 3px 3px 14px 0px rgba(24, 62, 100,0.1);
                        -o-box-shadow: 3px 3px 14px 0px rgba(24, 62, 100,0.1);
                        box-shadow: 3px 3px 14px 0px rgba(24, 62, 100,0.1);border-radius:10px;
                        display:flex;align-items:center;flex-direction:column;
                        padding-top:40px;
                        padding-bottom:40px;
                        padding-left:40px;
                        padding-right:40px;
                        box-sizing:border-box;
                        @media (max-width: 670px) {
                        width:100%;
                        box-shadow:none;
                        border:none;
    }`
                      }>


      <div className={css`
                    background-image: url(${pnc_logo});
                    background-position:center;
                    background-repeat:no-repeat;
                    background-size:cover;
                    width:100%;height:200px`}/>


      <div className={css`width:100%;padding-top:10px;font-size:12px;color:#7a7a7a`}>
        Bienvenue sur la plateforme de déclaration du Parc national des Calanques! Si vous avez déjà un compte sur  l’appli Mes Calanques, utilisez vos identifiants pour accéder à cette plateforme.
      </div>

      <div className={css`width:100%`}>
      <Input

                 style={{height:40,marginTop:20,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
                 inputStyle={{fontSize:15}}
                 labelStyle={{color:'#cccccc'}}
                 onChangeText={onChangeEmail} placeholder={'Votre email'} text={email}
                 error={emailError}

                 />
      </div>

  <div className={css`width:100%`}>
                 <InputPassword
                  style={{marginTop:30,height:40,paddingLeft:20,paddingRight:20,display:'flex',alignItems:'center',paddingTop:5,paddingBottom:5}}
                     inputStyle={{fontSize:15}}
                     labelStyle={{color:'#cccccc'}}
                     placeholder={"Votre mot de passe"}
                     value={password}
                     onBlur={onBlurPassword}
                     onChange={onChangePassword}
                     error={pwdError}

                   />
        </div>
        <div onClick={(e)=>{setForgetPassword(true)}} className={css`margin-top:20px;color:#0085C6;cursor:pointer;&:hover{text-decoration:underline}`}>Mot de passe oublié ?</div>
        <div className={css`margin-top:30px;width:100%;box-sizing:border-box`}>
        <ButtonEasy onPress={onSignIn} width='100%' height='40' text='Connectez-vous'/>
        </div>

        <div className={css`margin-top:20px`}>
          <span className={css`color:grey`}>Pas de compte ?</span> <span onClick={goToSignUp} className={css`cursor:pointer;color:#0085C6;&:hover{text-decoration:underline;}`}>Créez-en un !</span>
        </div>

      </div>

    {forgetPassword && <ModalForgetPassword onCloseModal={onCloseModal}/>}
    </div>
  )
}

export default LoginPage;
